import { black, black48, blackAlpha48, blueDarken16, blueDarken8 } from './colors';
import { rem } from './rem';
export const fontFamilyTitle = `'Telegraf', 'Helvetica Neue', Arial, sans-serif`;
export const fontFamilyBody = `'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif`;
const baseStyle = {
  marginTop: 0,
  marginBottom: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: black,
  fontStyle: 'normal'
};
const paragraphStyle = {
  'b, strong': {
    fontWeight: 500
  }
};
export const h1 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 700,
  fontSize: rem(40),
  lineHeight: 48 / 40,
  letterSpacing: -1
});
export const h2 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 700,
  fontSize: rem(34),
  lineHeight: 40 / 34,
  letterSpacing: -0.5
});
export const h3 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 700,
  fontSize: rem(28),
  lineHeight: 32 / 28
});
export const h4 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 700,
  letterSpacing: 0.25,
  fontSize: rem(24),
  lineHeight: 28 / 24
});
export const h5 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 700,
  fontSize: rem(20),
  lineHeight: 24 / 20
});
export const subtitle1 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 'normal',
  fontSize: rem(16),
  lineHeight: 24 / 16,
  letterSpacing: 0.25,
  color: black48
});
export const subtitle2 = Object.assign({}, baseStyle, {
  fontFamily: fontFamilyTitle,
  fontWeight: 'normal',
  fontSize: rem(14),
  lineHeight: 20 / 14,
  letterSpacing: 0.25,
  color: black48
});
export const body1 = Object.assign({}, baseStyle, paragraphStyle, {
  fontSize: rem(16),
  lineHeight: 24 / 16,
  letterSpacing: 0.5
});
export const body2 = Object.assign({}, baseStyle, paragraphStyle, {
  fontSize: rem(14),
  lineHeight: 20 / 14,
  letterSpacing: 0.25
});
export const caption = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: rem(12),
  lineHeight: 16 / 12,
  letterSpacing: 0.5,
  color: blackAlpha48
};
export const buttonLabel = Object.assign({}, baseStyle, {
  fontWeight: 500,
  fontSize: rem(14),
  lineHeight: 16 / 14
});
export const formLabel = Object.assign({}, baseStyle, {
  fontWeight: 500,
  fontSize: rem(14),
  lineHeight: 16 / 14,
  letterSpacing: 0.5
});
export const link = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: rem(14),
  lineHeight: 24 / 14,
  color: blueDarken8,
  cursor: 'pointer',
  ':hover, &.focus-visible': {
    textDecoration: 'underline'
  },
  ':active': {
    color: blueDarken16,
    textDecorationLine: 'underline'
  }
};
export const linkHover = Object.assign({}, link, {
  textDecorationLine: 'underline'
});
export const code = Object.assign({}, baseStyle, {
  fontWeight: 'normal',
  fontSize: rem(14),
  lineHeight: 24 / 14
});
export const overline = Object.assign({}, baseStyle, {
  fontWeight: 500,
  fontSize: rem(11),
  lineHeight: 14 / 11,
  textTransform: 'uppercase',
  letterSpacing: 1.5
});